module.exports = __webpack_public_path__ + "img/default-avatar@3x.6eff14d0.png";